import React from 'react'
import Grid from '../layout/grid'
import Trevo from '../../static/svg/trevo.svg'
import TrevoQuina from '../../static/svg/trevoQuina.svg'
import GloboLoteria from '../../static/svg/globoLoteria.svg'
import Report from '../../static/svg/report.svg'

export default props => (
    <a href='javascript:;' onClick={props.onClick}>
        <Grid cols='12 3 3'>
            <div className="box box-primary">
                <div className="box-body">
                    <div className="modalidade_row" key={props.chave}>
                        <img src={(props.title === 'A' || props.title === 'R' || props.title === 'E') ? Report : [555, 5555].includes(props.tipo)  ? TrevoQuina : [666, 6666,1515].includes(props.tipo) ? Trevo : GloboLoteria }  alt={props.title} className='img'/><span><h4>{props.name}</h4></span>
                    </div>
                </div>
            </div>
        </Grid>
    </a>
)


// WEBPACK FOOTER //
// ./src/common/widget/tipoAposta.jsx